import React from "react"
import PropTypes from "prop-types"
import {Avatar, Badge, Icon, Spin, Tooltip} from "antd"

export const checkBrowser = () => !!document.documentMode;

export const NavTo = ({link, containes}) => <a className={'sitedetail-url-website'} href={containes ? 'www.test.com' : 'https//:' + link} target={'_blank'} title={link}>{link}</a>;

export const StatusIndication = ({active}) => <Badge status={active ? 'success' : 'default'}/>;

StatusIndication.propTypes = {
    active: PropTypes.bool.isRequired
};

NavTo.propTypes = {
    link: PropTypes.string.isRequired,
    containes: PropTypes.bool.isRequired
};

export const defaultPagination = (pageSize = 20) => ({
    showSizeChanger: true,
    pageSize: pageSize,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
});

export const RenderValue = ({value}) => <Tooltip title={value.code}>{value.value}</Tooltip>;

export const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const toFilterItem = (it) => ({text: it, value: it});

export const makeDefaultFilters = (dataSource, selector) => dataSource
    .map(selector)
    .filter(onlyUnique)
    .map(toFilterItem);

export const DetailsTitle = ({icon, children}) => <span><Avatar className="details-avatar"
                                                                icon={icon}/> {children}</span>;

export const TextAligned = ({label, value}) => <div>
    <p style={{width: '49%', display: 'inline-block'}}>{label}:</p>
    <p style={{width: '50%', display: 'inline-block', color: 'black'}}>{value}</p>
</div>;

TextAligned.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node.isRequired
};

export const LoadingIndicator = ({loading, children}) => <Spin
    spinning={loading} indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
    {children}
</Spin>;

LoadingIndicator.propTypes = {
    loading: PropTypes.bool.isRequired
};

export const loadingConfig = (loading) => ({spinning: loading, indicator: <Icon type="loading" style={{fontSize: 24}} spin/>});

// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export const decodeJWT = (token) => {
    const firstIndex = token.indexOf(".");
    const lastIndex = token.lastIndexOf(".");
    const toDecode = token.substring(firstIndex + 1, lastIndex);
    const decoded = b64DecodeUnicode(toDecode);
    return JSON.parse(decoded)
};


// WEBPACK FOOTER //
// ./src/js/util/Util.js